import { z } from "zod";
export const agentTaskStatusSchema = z.enum([
    "pending",
    "in_progress",
    "completed",
    "cancelled",
]);
export const agentTaskPrioritySchema = z.enum(["high", "medium", "low"]);
export const agentTaskItemSchema = z
    .object({
    id: z
        .string()
        .trim()
        .min(1)
        .max(100)
        .regex(/^[a-z0-9][a-z0-9._:-]*$/),
    label: z.string().trim().min(1).max(500),
    status: agentTaskStatusSchema,
    priority: agentTaskPrioritySchema.optional(),
})
    .strict();
export const agentTaskListSchema = z
    .object({
    id: z
        .string()
        .trim()
        .min(1)
        .max(100)
        .regex(/^[a-z0-9][a-z0-9._:-]*$/),
    revision: z.number().int().positive(),
    source: z.enum(["opencode", "codex", "runtime"]),
    items: z.array(agentTaskItemSchema).min(1).max(32),
})
    .strict()
    .superRefine((value, context) => {
    const ids = new Set();
    for (const [index, item] of value.items.entries()) {
        if (ids.has(item.id)) {
            context.addIssue({
                code: "custom",
                path: ["items", index, "id"],
                message: "Task item IDs must be unique",
            });
        }
        ids.add(item.id);
    }
    if (value.items.filter(({ status }) => status === "in_progress").length > 1) {
        context.addIssue({
            code: "custom",
            path: ["items"],
            message: "A task list can have at most one in-progress item",
        });
    }
});
//# sourceMappingURL=task-lists.js.map